import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Panel } from 'primereact/panel';
import { ProgressBar } from 'primereact/progressbar';
import { Toast } from 'primereact/toast';
import { Checkbox } from 'primereact/checkbox';
import { Password } from 'primereact/password';
import { ImageSlotGrid } from '../../../../components/common/ImageSlotGrid';
import { User } from '../../../../../types/cms.types';
import { FileUploadService } from '../../../../../service/supabase/FileUploadService';

interface CpnCreateEditUserProps {
    visible: boolean;
    onHide: () => void;
    user: User | null;
    onSave: (userData: any) => void;
    isCreate?: boolean;
}

export const CpnCreateEditUser: React.FC<CpnCreateEditUserProps> = ({
    visible,
    onHide,
    user,
    onSave,
    isCreate = false
}) => {
    const [formData, setFormData] = useState({
        email: '',
        full_name: '',
        phone_number: '',
        pass_word: '',
        url_avatar: '',
        version_current_app: '',
        device: '',
        location_city: '',
        is_active: true,
        token_fcm: ''
    });

    const [uploadingFiles, setUploadingFiles] = useState<{ [key: string]: boolean }>({});
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [uploadProgress, setUploadProgress] = useState<{ [key: string]: number }>({});
    const toast = useRef<Toast>(null);

    // City options
    const cityOptions = [
        { label: 'Chưa chọn', value: '' },
        { label: 'An Giang', value: 'An Giang' },
        { label: 'Bà Rịa - Vũng Tàu', value: 'Bà Rịa - Vũng Tàu' },
        { label: 'Bắc Giang', value: 'Bắc Giang' },
        { label: 'Bắc Kạn', value: 'Bắc Kạn' },
        { label: 'Bạc Liêu', value: 'Bạc Liêu' },
        { label: 'Bắc Ninh', value: 'Bắc Ninh' },
        { label: 'Bến Tre', value: 'Bến Tre' },
        { label: 'Bình Định', value: 'Bình Định' },
        { label: 'Bình Dương', value: 'Bình Dương' },
        { label: 'Bình Phước', value: 'Bình Phước' },
        { label: 'Bình Thuận', value: 'Bình Thuận' },
        { label: 'Cà Mau', value: 'Cà Mau' },
        { label: 'Cần Thơ', value: 'Cần Thơ' },
        { label: 'Cao Bằng', value: 'Cao Bằng' },
        { label: 'Đà Nẵng', value: 'Đà Nẵng' },
        { label: 'Đắk Lắk', value: 'Đắk Lắk' },
        { label: 'Đắk Nông', value: 'Đắk Nông' },
        { label: 'Điện Biên', value: 'Điện Biên' },
        { label: 'Đồng Nai', value: 'Đồng Nai' },
        { label: 'Đồng Tháp', value: 'Đồng Tháp' },
        { label: 'Gia Lai', value: 'Gia Lai' },
        { label: 'Hà Giang', value: 'Hà Giang' },
        { label: 'Hà Nam', value: 'Hà Nam' },
        { label: 'Hà Nội', value: 'Hà Nội' },
        { label: 'Hà Tĩnh', value: 'Hà Tĩnh' },
        { label: 'Hải Dương', value: 'Hải Dương' },
        { label: 'Hải Phòng', value: 'Hải Phòng' },
        { label: 'Hậu Giang', value: 'Hậu Giang' },
        { label: 'TP.HCM', value: 'Hồ Chí Minh' },
        { label: 'Hòa Bình', value: 'Hòa Bình' },
        { label: 'Hưng Yên', value: 'Hưng Yên' },
        { label: 'Khánh Hòa', value: 'Khánh Hòa' },
        { label: 'Kiên Giang', value: 'Kiên Giang' },
        { label: 'Kon Tum', value: 'Kon Tum' },
        { label: 'Lai Châu', value: 'Lai Châu' },
        { label: 'Lâm Đồng', value: 'Lâm Đồng' },
        { label: 'Lạng Sơn', value: 'Lạng Sơn' },
        { label: 'Lào Cai', value: 'Lào Cai' },
        { label: 'Long An', value: 'Long An' },
        { label: 'Nam Định', value: 'Nam Định' },
        { label: 'Nghệ An', value: 'Nghệ An' },
        { label: 'Ninh Bình', value: 'Ninh Bình' },
        { label: 'Ninh Thuận', value: 'Ninh Thuận' },
        { label: 'Phú Thọ', value: 'Phú Thọ' },
        { label: 'Phú Yên', value: 'Phú Yên' },
        { label: 'Quảng Bình', value: 'Quảng Bình' },
        { label: 'Quảng Nam', value: 'Quảng Nam' },
        { label: 'Quảng Ngãi', value: 'Quảng Ngãi' },
        { label: 'Quảng Ninh', value: 'Quảng Ninh' },
        { label: 'Quảng Trị', value: 'Quảng Trị' },
        { label: 'Sóc Trăng', value: 'Sóc Trăng' },
        { label: 'Sơn La', value: 'Sơn La' },
        { label: 'Tây Ninh', value: 'Tây Ninh' },
        { label: 'Thái Bình', value: 'Thái Bình' },
        { label: 'Thái Nguyên', value: 'Thái Nguyên' },
        { label: 'Thanh Hóa', value: 'Thanh Hóa' },
        { label: 'Thừa Thiên Huế', value: 'Thừa Thiên Huế' },
        { label: 'Tiền Giang', value: 'Tiền Giang' },
        { label: 'Trà Vinh', value: 'Trà Vinh' },
        { label: 'Tuyên Quang', value: 'Tuyên Quang' },
        { label: 'Vĩnh Long', value: 'Vĩnh Long' },
        { label: 'Vĩnh Phúc', value: 'Vĩnh Phúc' },
        { label: 'Yên Bái', value: 'Yên Bái' }
    ];

    // Image upload handlers
    const handleImageAdd = async (fieldName: string, index: number, file: File) => {
        try {
            const loadingKey = `${fieldName}_${index}`;
            setUploadingFiles(prev => ({ ...prev, [loadingKey]: true }));
            setUploadProgress(prev => ({ ...prev, [loadingKey]: 0 }));
            setIsLoading(true);

            const progressInterval = setInterval(() => {
                setUploadProgress(prev => {
                    const current = prev[loadingKey] || 0;
                    if (current < 80) {
                        return { ...prev, [loadingKey]: current + 10 };
                    }
                    return prev;
                });
            }, 200);

            const phoneNumber = formData.phone_number || 'temp';
            const fileUrl = await FileUploadService.uploadDriverDocument(
                file,
                phoneNumber,
                fieldName
            );

            if (!fileUrl) {
                console.error('Failed to upload file');
                clearInterval(progressInterval);
                return;
            }

            setUploadProgress(prev => ({ ...prev, [loadingKey]: 100 }));
            clearInterval(progressInterval);

            setFormData(prev => ({
                ...prev,
                [fieldName]: fileUrl
            }));

            toast.current?.show({
                severity: 'success',
                summary: 'Thành công',
                detail: 'Tải ảnh lên thành công!',
                life: 3000
            });
        } catch (error) {
            console.error('Error uploading file:', error);
            toast.current?.show({
                severity: 'error',
                summary: 'Lỗi',
                detail: 'Có lỗi xảy ra khi tải ảnh lên. Vui lòng thử lại.',
                life: 5000
            });
        } finally {
            const loadingKey = `${fieldName}_${index}`;
            setUploadingFiles(prev => {
                const newState = { ...prev };
                delete newState[loadingKey];
                return newState;
            });
            setUploadProgress(prev => {
                const newState = { ...prev };
                delete newState[loadingKey];
                return newState;
            });
            setIsLoading(false);
        }
    };

    const handleImageRemove = async (fieldName: string, index: number) => {
        try {
            const loadingKey = `${fieldName}_${index}_remove`;
            setUploadingFiles(prev => ({ ...prev, [loadingKey]: true }));
            setIsLoading(true);

            const fileUrl = formData[fieldName as keyof typeof formData] as string;
            if (fileUrl) {
                await FileUploadService.deleteFile(fileUrl);
            }

            setFormData(prev => ({
                ...prev,
                [fieldName]: ''
            }));

            toast.current?.show({
                severity: 'info',
                summary: 'Đã xóa',
                detail: 'Ảnh đã được xóa thành công!',
                life: 3000
            });
        } catch (error) {
            console.error('Error deleting file:', error);
            toast.current?.show({
                severity: 'error',
                summary: 'Lỗi',
                detail: 'Có lỗi xảy ra khi xóa ảnh. Vui lòng thử lại.',
                life: 5000
            });
        } finally {
            const loadingKey = `${fieldName}_${index}_remove`;
            setUploadingFiles(prev => {
                const newState = { ...prev };
                delete newState[loadingKey];
                return newState;
            });
            setIsLoading(false);
        }
    };

    const isFieldUploading = (fieldName: string, index?: number) => {
        const loadingKey = index !== undefined ? `${fieldName}_${index}` : fieldName;
        const removeKey = index !== undefined ? `${fieldName}_${index}_remove` : `${fieldName}_remove`;
        return uploadingFiles[loadingKey] || uploadingFiles[removeKey] || false;
    };

    // Load user data when dialog opens
    useEffect(() => {
        if (visible && user && !isCreate) {
            setFormData({
                email: user.email || '',
                full_name: user.full_name || '',
                phone_number: user.phone_number || '',
                pass_word: '', // Don't load password for security
                url_avatar: user.url_avatar || '',
                version_current_app: user.version_current_app || '',
                device: user.device || '',
                location_city: user.location_city || '',
                is_active: user.is_active ?? true,
                token_fcm: user.token_fcm || ''
            });
        } else if (visible && isCreate) {
            // Reset form for create mode
            setFormData({
                email: '',
                full_name: '',
                phone_number: '',
                pass_word: '',
                url_avatar: '',
                version_current_app: '',
                device: '',
                location_city: '',
                is_active: true,
                token_fcm: ''
            });
        }
    }, [visible, user, isCreate]);

    const handleInputChange = (field: string, value: any) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleClose = () => {
        if (!isSaving) {
            onHide();
        }
    };

    const handleSave = async () => {
        try {
            setIsSaving(true);

            toast.current?.show({
                severity: 'info',
                summary: 'Đang xử lý',
                detail: `Đang ${isCreate ? 'tạo' : 'cập nhật'} thông tin người dùng...`,
                life: 2000
            });

            await onSave(formData);

            toast.current?.show({
                severity: 'success',
                summary: 'Thành công',
                detail: `${isCreate ? 'Tạo' : 'Cập nhật'} thông tin người dùng thành công!`,
                life: 3000
            });
        } catch (error) {
            console.error('Error saving user data:', error);
            toast.current?.show({
                severity: 'error',
                summary: 'Lỗi',
                detail: 'Có lỗi xảy ra khi lưu thông tin. Vui lòng thử lại.',
                life: 5000
            });
        } finally {
            setIsSaving(false);
        }
    };

    const isFormValid = () => {
        const required = ['full_name', 'phone_number'];

        // If creating new user, password is required
        if (isCreate) {
            required.push('pass_word');
        }

        return required.every(field => {
            const value = formData[field as keyof typeof formData];
            return value !== '' && value !== null && value !== undefined;
        });
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={visible}
                onHide={handleClose}
                header={isCreate ? 'Tạo người dùng mới' : `Chỉnh sửa thông tin: ${user?.full_name || 'Không xác định'}`}
                style={{ width: '90vw', maxWidth: '800px' }}
                maximizable
                modal
                closable={!isSaving}
                footer={
                    <div className="flex justify-end gap-2">
                        <Button
                            label="Hủy"
                            icon="pi pi-times"
                            onClick={handleClose}
                            className="p-button-text"
                            disabled={isLoading || isSaving}
                        />
                        <Button
                            label={isSaving ? "Đang lưu..." : "Lưu thay đổi"}
                            icon={isSaving ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            onClick={handleSave}
                            disabled={!isFormValid() || isLoading || isSaving}
                            className="p-button-success"
                            loading={isSaving}
                        />
                    </div>
                }
            >
                <div className="space-y-4">
                    {/* Basic Information */}
                    <Panel header="Thông tin cơ bản" toggleable>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium mb-1">
                                    Họ và tên <span className="text-red-500">*</span>
                                </label>
                                <InputText
                                    value={formData.full_name}
                                    onChange={(e) => handleInputChange('full_name', e.target.value)}
                                    className="w-full"
                                    placeholder="Nhập họ và tên"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium mb-1">
                                    Số điện thoại <span className="text-red-500">*</span>
                                </label>
                                <InputText
                                    value={formData.phone_number}
                                    onChange={(e) => handleInputChange('phone_number', e.target.value)}
                                    className="w-full"
                                    placeholder="Nhập số điện thoại"
                                    disabled={!isCreate} // Cannot change phone number when editing
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium mb-1">Email</label>
                                <InputText
                                    value={formData.email}
                                    onChange={(e) => handleInputChange('email', e.target.value)}
                                    className="w-full"
                                    placeholder="Nhập email"
                                    type="email"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium mb-1">
                                    Mật khẩu {isCreate && <span className="text-red-500">*</span>}
                                </label>
                                <Password
                                    value={formData.pass_word}
                                    onChange={(e) => handleInputChange('pass_word', e.target.value)}
                                    className="w-full"
                                    inputClassName="w-full"
                                    placeholder={isCreate ? "Nhập mật khẩu" : "Để trống nếu không đổi"}
                                    toggleMask
                                    feedback={isCreate}
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium mb-1">Thành phố</label>
                                <Dropdown
                                    value={formData.location_city}
                                    options={cityOptions}
                                    onChange={(e) => handleInputChange('location_city', e.value)}
                                    className="w-full"
                                    placeholder="Chọn thành phố"
                                    filter
                                    showClear
                                />
                            </div>

                            <div className="flex items-center gap-2 pt-6">
                                <Checkbox
                                    inputId="is_active"
                                    checked={formData.is_active}
                                    onChange={(e) => handleInputChange('is_active', e.checked)}
                                />
                                <label htmlFor="is_active" className="text-sm font-medium cursor-pointer">
                                    Tài khoản đang hoạt động
                                </label>
                            </div>
                        </div>
                    </Panel>

                    {/* Device Information */}
                    <Panel header="Thông tin thiết bị" toggleable collapsed>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium mb-1">Phiên bản ứng dụng</label>
                                <InputText
                                    value={formData.version_current_app}
                                    onChange={(e) => handleInputChange('version_current_app', e.target.value)}
                                    className="w-full"
                                    placeholder="Ví dụ: 1.0.0"
                                    disabled
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium mb-1">Thiết bị</label>
                                <InputText
                                    value={formData.device}
                                    onChange={(e) => handleInputChange('device', e.target.value)}
                                    className="w-full"
                                    placeholder="Ví dụ: iPhone 13, Samsung Galaxy S21"
                                    disabled
                                />
                            </div>

                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium mb-1">FCM Token</label>
                                <InputText
                                    value={formData.token_fcm}
                                    onChange={(e) => handleInputChange('token_fcm', e.target.value)}
                                    className="w-full"
                                    placeholder="Token FCM cho push notification"
                                    disabled
                                />
                            </div>
                        </div>
                    </Panel>

                    {/* Avatar */}
                    <Panel header="Ảnh đại diện" toggleable collapsed>
                        <div className="relative">
                            <ImageSlotGrid
                                label="Ảnh đại diện"
                                images={formData.url_avatar ? [formData.url_avatar] : []}
                                maxImages={1}
                                onImageAdd={(index, file) => handleImageAdd('url_avatar', index, file)}
                                onImageRemove={(index) => handleImageRemove('url_avatar', index)}
                                accept="image/*"
                                slotWidth="200px"
                                slotHeight="200px"
                                description="1 ảnh đại diện"
                                disabled={isFieldUploading('url_avatar', 0)}
                            />
                            {isFieldUploading('url_avatar', 0) && (
                                <div className="absolute inset-0 bg-white bg-opacity-80 flex items-center justify-center rounded-lg">
                                    <div className="flex flex-col items-center space-y-3">
                                        <i className="pi pi-spin pi-spinner text-blue-500 text-xl"></i>
                                        <span className="text-sm text-gray-600">Đang tải ảnh...</span>
                                        <ProgressBar
                                            value={uploadProgress['url_avatar_0'] || 0}
                                            className="w-32"
                                            showValue={false}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </Panel>
                </div>
            </Dialog>
        </>
    );
};
